import { createStore, applyMiddleware, compose, combineReducers } from "redux"
import { routerMiddleware, routerReducer } from "react-router-redux"
import persistState from "redux-localstorage"
import thunk from "redux-thunk"
import { createBrowserHistory } from "history"
import { camelCase } from "lodash"

// REDUCERS
let reducers = {}
let defaults = {}
const reducersReq = require.context("../reducers", true, /^(.*\.(js$))[^.]*$/im)
reducersReq.keys().forEach(key => {
  const reducerName = camelCase(key.match(/.\/([\w-]+).js/)[1])
  reducers[reducerName] = reducersReq(key).default
  defaults[reducerName] = reducersReq(key)[`${reducerName}ReducerDefaultState`]
})

export const history = createBrowserHistory()

export const initialState = {}
export const enhancers = []
export const middleware = [thunk, routerMiddleware(history)]

enhancers.push(
  persistState(null, {
    key: "BIDR-DIGITAL-SIGNAGE-2",
    slicer: paths => {
      return state => {
        return {}
      }
    }
  })
)

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  combineReducers({
    routing: routerReducer,
    ...reducers
  }),
  initialState,
  composedEnhancers
)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js